<!--
frontend-author:bhavya, Vaishnavi,
page-name : RetainerInvoice.vue,
page-description : RetainerInvoice for invoice,
started at : 22-june-2019,
-->
<!-- Html code for Retainer Invoice-->
<template>
  <div class="retainer" style="margin-top:-10px;">
    <!-- page title for payment create -->
    <GlobalHeader title="Customer Deposit" @redirectPage="redirectPage"></GlobalHeader>
    <!--  Validation -->
    <b-row class="mt-2 px-pad">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
        <div class="container-fluid">
          <b-alert class="alert-transparent alert-danger" :show="duplicatecode">
            <p class="fw-semi-bold">{{ message }}</p>
          </b-alert>
          <b-alert class="alert-transparent alert-danger" :show="error_show  && this.errors.any()">
            <button type="button" @click="error_show=!error_show" class="close">
              <span aria-hidden="true">&times;</span>
            </button>
            <div
              v-for="item in errors.items"
              :key="item.id"
              v-if="item.scope=='customer-deposit-form'"
            >
              <p class="fw-semi-bold">{{ item.msg }}</p>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-row>
    <b-form
      @submit.prevent="onSubmit('customer-deposit-form')"
      id="customer_form"
      data-vv-scope="customer-deposit-form"
      class="mt-1"
      style="margin-left:3px;margin-right:3px;"
    >
      <div class="sales-bg pt-30p pb-4 mb-2 border-bottom-dot" style="background:#f7f7f7">
        <!--  customer input block -->
        <b-row>
          <b-col xl="10" lg="9" md="9" sm="12" xs="12" @click="removecustomer" class="pr-1">
            <b-form-group>
              <div class="input-group">
                <vue-bootstrap-typeahead
                  v-show="(!$route.query.quot_id)&&(page == 'create' || (list.header_details.retainer_status_id <= 5))"
                  id="customer_search"
                  placeholder="Type to search customer"
                  class="customer_search"
                  :data="customers"
                  :serializer="customer => customer.label"
                  ref="cus_name_typeahead"
                  @hit="checkpos($event)"
                  v-model="cus_id"
                  title="Enter first three characters of customer to search"
                />

                <div class="input-group-append">
                  <input
                    style="border-right: 0 !important;"
                    v-show="$route.query.quot_id||(page == 'update' && list.header_details.retainer_status_id >= 6)"
                    type="text"
                    class="form-control input_customer_search"
                    v-model="cus_id"
                    readonly
                  />
                  <b-dropdown
                    class="advance-search-option btn-radius-unset text-center"
                    size="sm"
                    variant="light"
                    :text="search_value"
                    style="height:32px;"
                  >
                    <b-dropdown-item
                      @click="search_column = 'cus_display_name',search_value='Customer Name'"
                    >Customer Name</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_ph_no_1',search_value='Phone Number'"
                    >Phone Number</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_legacy_id',search_value='Customer ID'"
                    >Customer ID</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_gst_no',search_value='Gst Number'"
                    >Gst Number</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_pan_no',search_value='PAN Number'"
                    >PAN Number</b-dropdown-item>
                  </b-dropdown>

                  <input
                    type="hidden"
                    name="cus_id"
                    class="form-control"
                    v-model="field.cus_id"
                    data-vv-name="customer name"
                    v-validate="'required'"
                  />
                  <span
                    class="ml-2 mt-2 mr-1 cursor_pointer"
                    v-b-tooltip
                    title="View Customer Details"
                    v-if="field.cus_id != ''&&RoutePermission(false,'','invoice','customer','index')"
                    @click="toggleCustomerDetails()"
                  >
                    <i class="la la-external-link la-lg"></i>
                  </span>
                </div>
                <span v-if="field.cus_id != ''" class="pl-1 mt-2 cursor_pointer">
                  <b-badge variant="success" size="xs">{{field.currency_code}}</b-badge>
                </span>
              </div>
            </b-form-group>
          </b-col>
          <b-col xl="2" lg="3" md="3" sm="3" xs="3" class="text-right pl-0">
            <h3
              style="margin-bottom:0px"
              class="text-truncate"
              v-b-tooltip
              :title="parseFloat(total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 })"
            >
              {{ getDetails(
              this.$AppDetails.currency_details,
              (field.cus_currency || $AppDetails.organization.org_currency),
              "currency_symbol"
              )+" "+parseFloat(total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
            </h3>
          </b-col>
        </b-row>
      </div>
      <b-row style="max-width:1000px;" class="mt-4">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            v-if="retainer_settings_details.retain_inv_code_field"
            :label="'Customer Deposit'"
            label-class="required"
            label-for="customer-deposit-code"
            class="mb-3"
          >
            <b-input-group class="vselect-custom-add">
              <template slot="append">
                <b-input-group-text
                  class="vselect-custom-add-icon"
                  v-b-tooltip
                  title="Customize auto generate code"
                  style="margin-left:2px;"
                  v-on:click="$root.$emit('bv::show::modal', 'addautogeneratecode')"
                >
                  <i class="la la-cog"></i>
                </b-input-group-text>
              </template>

              <template slot="prepend">
                <b-form-input
                  style="border-top-right-radius:0 !important;border-bottom-right-radius:0 !important"
                  type="text"
                  size="sm"
                  name="Customer Deposit"
                  v-model.trim="field.retainer_no"
                  data-vv-name="customer deposit"
                  v-validate="'required|max:16'"
                />
              </template>
            </b-input-group>
          </b-form-group>
          <b-form-group :label="' Reference No'" label-for="Reference" class="mb-3">
            <b-form-input
              type="text"
              size="sm"
              name="ref_no"
              data-vv-name="reference no"
              v-model.trim="field.ref_no"
              v-validate="'max:30'"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            :label="'Payment date'"
            label-class="required"
            label-for="Payment Date"
            class="mb-3"
          >
            <DatePicker
              placeholder=" "
              :format="$AppDetails.organization.date_format"
              data-vv-name="retainer date"
              v-validate="'required'"
              input-name="created_date"
              lang="en"
              input-class="form-control"
              @change="selectDate"
              style="width:100% !important;"
              name="retainer_date"
              v-model.trim="field.retainer_date"
            >
              <i class="fa fa-calendar text-dark" slot="calendar-icon" />
            </DatePicker>
          </b-form-group>
        </b-col>
      </b-row>

      <template v-if="retainer_settings_details.custom_field.length > 0">
        <b-row style="max-width:1000px" class="mt-4 mb-2 pt-2">
          <b-col>
            <h6
              class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
              v-b-toggle.collapse-1
            >
              Custom fields
              <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
            </h6>
          </b-col>
        </b-row>

        <b-collapse id="collapse-1" visible>
          <b-row style="max-width:1000px;">
            <b-col
              cols="12"
              lg="5"
              md="6"
              sm="8"
              :key="index"
              v-for="(custom_field,index) in retainer_settings_details.custom_field"
              v-if="custom_field.status == 1 && custom_field.permissions == 'write'"
            >
              <CustomPreview
                v-on:assigncustomvalue="assigncustomvalue($event)"
                :custom="custom_field"
                :disabled="false"
                :modelname="field[custom_field.field_name]"
              />
              <input
                type="hidden"
                :name="custom_field.label_name"
                :data-vv-name="custom_field.label_name"
                v-validate="custom_field.validation"
                v-model="field[custom_field.field_name]"
              />
            </b-col>
          </b-row>
        </b-collapse>
      </template>

      <b-row class="mt-5" style="max-width:900px;display:flow-root">
        <b-col md="12">
          <span
            class="float-right display-flex fw-semi-bold"
            style="margin-right:35px"
            v-if="field.is_export == 2"
          >
            <span
              v-if=" currency_details.exchange_rate_date!=''||org_details.exchange_rate_status==0"
            >
              <small v-if="changed_currency==false" class="d-block">Exchange rate as on creation,</small>
              <small
                v-else
                class="d-block"
              >As of Date: {{currency_details.exchange_rate_date!=''?getDateFormat(currency_details.exchange_rate_date):getDateFormat(field.retainer_date)}}</small>
              <span class="float-right" style="font-size:11px;">
                1 {{field.currency_code}} = {{parseFloat(field.unit_currency_value)}} {{orgCurrency}}
                <span>
                  <b-dropdown
                    class="exchange-dropdown"
                    right
                    toggle-class="p-0 text-decoration-none"
                    variant="link"
                    no-caret
                    size="xs"
                    ref="exchange_rate_dropdown"
                  >
                    <template slot="button-content">
                      <i
                        class="la la-edit la-lg theme-text-color pl-1"
                        style="top:-3px;position:relative"
                        @click="exchange_rate_details={ currency_exchange_rate: field.unit_currency_value , save_exchange_rate: 0, recalc: 0 }"
                      ></i>
                    </template>
                    <b-dropdown-header>Edit Exchange Rate</b-dropdown-header>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-form class="p-3" style="width:250px;">
                      <b-row>
                        <b-col>
                          <b-form-group
                            :label="'Exchange Rate(in '+orgCurrency+')'"
                            label-class="required"
                            label-for="ex-rate"
                          >
                            <b-input
                              @blur="exchange_rate_details.currency_exchange_rate = exchange_rate_details.currency_exchange_rate==''||parseFloat(exchange_rate_details.currency_exchange_rate) <=  0||parseFloat(exchange_rate_details.currency_exchange_rate) >  100000000000000||isNaN(parseFloat(exchange_rate_details.currency_exchange_rate))? 1 : parseFloat(exchange_rate_details.currency_exchange_rate)"
                              v-model="exchange_rate_details.currency_exchange_rate"
                            ></b-input>
                          </b-form-group>
                          <b-checkbox
                            v-if="org_details.exchange_rate_status==1&&page=='create'"
                            unchecked-value="0"
                            value="1"
                            v-model="exchange_rate_details.save_exchange_rate"
                            class="mt-2"
                          >
                            <small>Set this rate as default for {{getDateFormat(field.retainer_date)}}</small>
                          </b-checkbox>
                          <b-checkbox
                            unchecked-value="0"
                            value="1"
                            v-model="exchange_rate_details.recalc"
                            class="mt-2"
                          >
                            <small>Re-calculate item prices based on this rate</small>
                          </b-checkbox>
                        </b-col>
                      </b-row>
                      <b-row class="mt-3">
                        <b-col>
                          <b-button variant="primary" size="xs" @click="exchangeRateSubmit()">Save</b-button>
                        </b-col>
                      </b-row>
                    </b-dropdown-form>
                  </b-dropdown>
                </span>
              </span>
            </span>
            <template v-else>
              <b-form-group
                label="Exchange rate"
                label-class="required"
                label-cols="4"
                label-for="currency"
              >
                <b-input-group
                  size="sm"
                  :append="orgCurrency"
                  :prepend="'1 '+getDetails(
                    this.$AppDetails.currency_details,
                    field.cus_currency,
                    'currency_code'
                    ) +' = '"
                >
                  <b-form-input
                    @blur="changeExchangeRate()"
                    type="text"
                    class="text-right"
                    v-model.trim="field.unit_currency_value"
                    name="Currency"
                    data-vv-name="currency"
                    v-validate="'required|decimal:5|excluded:'+parseFloat(0).toFixed(2)+'|min_value:0'"
                  ></b-form-input>
                </b-input-group>
                <small
                  v-if="org_details.exchange_rate_status==1&&page!='update'"
                  class="text-muted"
                >This will be set as the exchange rate for this date.</small>
              </b-form-group>
            </template>
          </span>
        </b-col>
      </b-row>

      <!--  Table for retainer -->
      <div class="mt-3">
        <b-row style="max-width:1000px;">
          <b-col xl="12" lg="12" md="12" sm="12" xs="12">
            <div class="table-responsive">
              <table class="table table-bordered sales-table last-child-border-none">
                <thead>
                  <!-- <th width="10%">#</th> -->
                  <th width="75%">Description</th>
                  <th class="text-right">
                    Amount ( {{ getDetails(
                    this.$AppDetails.currency_details,
                    field.cus_currency,
                    "currency_code"
                    ) || orgCurrency }})
                  </th>
                  <th width="1%"></th>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in items" :key="index">
                    <!-- <td>{{index + 1}}</td> -->
                    <td>
                      <b-form-textarea
                        class="form-control"
                        :data-vv-name="'row '+(index+1)+' description'"
                        v-validate="'required|max:250'"
                        :rows="2"
                        :name="'retainer_desc['+index+']'"
                        id="description"
                        v-model="item.retainer_desc"
                      />
                    </td>
                    <td class="text-right">
                      <input
                        class="text-right form-control"
                        type="text"
                        :data-vv-name="'row '+(index+1)+' amount'"
                        @blur="roundOffItem(index,'retainer_amt',6)"
                        v-validate="'required|max_value:100000000000000|decimal:6'"
                        :name="'retainer_amt['+index+']'"
                        style="border:none;"
                        v-model.trim="item.retainer_amt"
                      />
                    </td>
                    <td>
                      <i
                        class="glyphicon glyphicon-trash mt-2 cursor_pointer"
                        @click="removeRow(index)"
                      ></i>
                    </td>
                  </tr>
                  <tr>
                    <td class="no-border">
                      <p class="pt-2 mb-1">
                        <span
                          class="addline theme-text-color cursor_pointer pt-2"
                          @click="addNewRow()"
                        >Add Lines</span>
                        <span class="float-right fw-semi-bold">
                          Total ( {{ getDetails(
                          this.$AppDetails.currency_details,
                          field.cus_currency,
                          "currency_symbol"
                          ) || orgCurrencySymbol }} )
                        </span>
                      </p>
                    </td>
                    <td
                      class="no-border text-right"
                      style="max-width:214px !important;word-break:break-word !important"
                    >
                      <p
                        class="fw-semi-bold pt-2 mr-2 mb-1"
                      >{{ parseFloat(total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
      </div>

      <input
        v-if="page=='update'"
        type="hidden"
        name="paid_status"
        data-vv-name="paid status"
        :value="list.header_details.retainer_total"
        v-validate="page == 'update' && list.header_details.retainer_status_id >=6 ? 'required|max_value:'+parseFloat(list.header_details.received_amount).toFixed(2)+'|min_value:'+parseFloat(list.header_details.received_amount).toFixed(2) : ''"
      />

      <b-form-group class="mb-1 mt-5 pt-5">
        <b-row style="max-width:600px;">
          <b-col xl="12" lg="12" md="12" sm="12" xs="12">
            <label>Customer Notes</label>
            <b-form-textarea
              @input="deposit_desc_changed=true"
              name="cus_inv_notes"
              :rows="4"
              data-vv-name="customer notes"
              id="cus_inv_notes"
              v-validate="'max:250'"
              v-model="field.cus_inv_notes"
            />
            <b-form-checkbox
              v-if="deposit_desc_changed==true"
              id="deposit_desc_changed"
              v-model.trim="field.deposit_desc_changed"
              name="deposit_desc_changed"
              value="1"
              unchecked-value="0"
            >Use this in future.</b-form-checkbox>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="mb-1 mt-4 pb-4">
        <b-row style="max-width:600px;">
          <b-col xl="12" lg="12" md="12" sm="12" xs="12">
            <label>Terms & Conditions</label>
            <b-form-textarea
              @input="deposit_term_changed=true"
              name="retainer_terms_cndtn"
              :rows="4"
              data-vv-name="terms and conditions"
              id="retainer_terms_cndtn"
              v-validate="'max:250'"
              v-model="field.retainer_terms_cndtn"
            />
            <b-form-checkbox
              v-if="deposit_term_changed==true"
              id="deposit_term_changed"
              v-model.trim="field.deposit_term_changed"
              name="deposit_term_changed"
              value="1"
              unchecked-value="0"
            >Use this in future.</b-form-checkbox>
          </b-col>
        </b-row>
      </b-form-group>
      <!-- footer block -->

      <div class="footer" style="box-shadow:0 0 5px #ccc;">
        <div :class="{'form-action' : true}">
          <b-button
            v-if="page =='create'"
            type="submit"
            variant="primary"
            class="btn-rounded mr-3"
            :disabled="submitted"
          >
            <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Save
          </b-button>
          <template v-if="page =='update'">
            <b-button
              type="submit"
              variant="primary"
              class="btn-rounded mr-3"
              :disabled="submitted"
            >
              <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Update
            </b-button>
          </template>
        </div>
      </div>
    </b-form>
    <ShowCustomerDetails v-if="customer_details == 1"></ShowCustomerDetails>
    <AutoGenerateCode v-on:setCodeValue="getCodeValue($event)" :type="field.type||'customer_deposit'"></AutoGenerateCode>
    <!-- Modal for change exchange rate value change warning message -->
    <ExchangeRateWarning></ExchangeRateWarning>
  </div>
</template>
<script scoped>
// import all the components, files and funciton
import AutoGenerateCode from "@/components/Modal/AutoGenerateCode";
import getPageTitle from "@/utils/get-page-title"; // to set page title
import DatePicker from "vue2-datepicker"; // vue datepicker
import $ from "jquery"; // for using jquery function
import vSelect from "vue-select"; // searchable select dropdwon
import { mapState, mapGetters } from "vuex"; // get data set in the state in vuex
import { notificationMixin } from "@/mixins/notification"; // global function for calling notification
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling notification
import VueBootstrapTypeahead from "vue-bootstrap-typeahead"; // data on search api calls
import CustomPreview from "@/components/Form/Settings/CustomPreview";
import ShowCustomerDetails from "@/components/Form/Customer/ShowCustomerDetails";
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import ExchangeRateWarning from "@/components/Modal/ExchangeRateWarning"; //for Exchange rate change warning message in modal
export default {
  props: ["page", "duplicatecode", "submitted"],
  mixins: [notificationMixin, formatDate],
  name: "RetainerInvoice", // page name
  components: {
    DatePicker, //datepicker
    vSelect, //vue select
    VueBootstrapTypeahead, //on change api
    AutoGenerateCode,
    ShowCustomerDetails,
    CustomPreview,
    ExchangeRateWarning //modal component for exchange rate changes
  },
  data() {
    return {
      retainerCollapse: "",
      search_value: "Customer Name",
      search_column: "cus_display_name",
      update_price: false,
      field: this.createFreshEventObject(),
      cus_id: "",
      customers: [],
      total_header: "0.00",
      amount: "",
      retainer_total: "",
      inv_notes: "", //inv notes
      index: "",

      error_show: false, // to show the error message
      old_retainer_itm_ids: "",
      //items arrays are declared
      items: [
        {
          retainer_itm_id: "",
          retainer_amt: "",
          retainer_desc: ""
        }
      ],
      customer_details: 0,
      old_cus_id: "",
      old_currency_code: "",
      changed_currency: true,
      exchange_rate_details: {
        currency_exchange_rate: 1,
        save_exchange_rate: 0,
        recalc: 0
      },
      old_exchange_rate: 1,
      deposit_desc_changed: false,
      deposit_term_changed: false
    };
  },
  //
  methods: {
    redirectPage(){
              if(this.$route.query.customer_id){
                this.$router.push({name:'CustomerView',params:{id:this.$route.query.customer_id}})
              }
              else if(this.$route.query.quot_id){
                this.$router.push({name:'SalesView',params:{id:this.$route.query.quot_id}})
              }
              else if(this.$route.query.page_from=='view'&&(this.$route.params.id||this.$route.query.old_id)){
              this.$router.push({name:'RetainerInvoiceView',params:{id:this.$route.params.id||this.$route.query.old_id}})
     }
   else {
        if (this.$store.state.retainer.retainer_index_history) {
          this.$router.push(this.$store.state.retainer.retainer_index_history);
        } else {
          this.$router.push({ name: "RetainerInvoice" });
        }
      }
    },

    //  assign custom value
    assigncustomvalue(ev) {
      this.field[ev.field] = ev.value;
    },
    //  update code details
    getCodeValue(ev) {
      this.field.code_id = ev.code_id;
      this.field.suffix = ev.suffix;
      this.field.prefix = ev.prefix;
      this.field.retainer_no = ev.prefix + ev.suffix;
    },
    //Customer details
    async toggleCustomerDetails() {
       await this.$store
          .dispatch("customer/fetchViewList", this.field.cus_id).then(response=>{
            if(response.data.code!=200){
              this.customer_details = 0;
              window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: response.data.status,
              type: response.data.type,
              showCloseButton: true,
            });
            }else{
              this.customer_details = 1;
            }
          })
          if(this.customer_details == 1){
            await EventBus.$emit("toggleCustomerDetails");
          }
    },
    //  round off line item amount to two deximal values
    roundOffItem(index, field, digits) {
      var digit = parseInt(digits);
      this.items[index][field] =
        typeof this.items[index][field] != undefined &&
        !isNaN(this.items[index][field]) &&
        this.items[index][field] != ""
          ? parseFloat(parseFloat(this.items[index][field]).toFixed(digit))
          : parseFloat(parseFloat(0).toFixed(digit));
    },
    selectDate(val) {
      //  if the payment term in selected customer not empty enter into condition
      this.field.retainer_date =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
      if (this.changed_currency) {
        this.getExchangeRateValue(1);
      }
    },
    checkpos(event) {
      if (this.update_price == true) {
        //  design for selected customer inpout field
        $("#customer_search input").addClass("mask");
        $("#customer_search .input-group").append(
          "<span class='la la-close p-2 mt-1 remover cursor_pointer bg-white'></span>"
        );
        this.field.cus_id = event.value; // assgin the selected customer id to cus id modal
        this.customer_details = 0;
        //  check for foreign currency
        if (event.currency != this.$AppDetails.organization.org_currency) {
          this.field.is_export = 2;
          this.field.place_of_supply = {
            label: this.getDetails(
              this.$AppDetails.state_details,
              "97",
              "state_name"
            ),
            value: 97
          };
        } else {
          this.field.is_export = 1;
          this.field.place_of_supply = {
            label: this.getDetails(
              this.$AppDetails.state_details,
              event.pos,
              "state_name"
            ),
            value: event.pos
          };
        }
        this.field.cus_currency = event.currency;
        this.getExchangeRateValue(0);
      }
    },
    //  remove the design of removed customer
    removecustomer(e) {
      if (e.target.matches(".remover")) {
        this.customer_details = 0;
        $("#customer_search input").removeClass("mask");
        $("#customer_search .input-group .remover").remove();
        this.old_cus_id = this.field.cus_id;
        this.old_currency_code = this.field.currency_code;
        this.old_exchange_rate = this.field.unit_currency_value;
        this.field.cus_id = "";
        this.$refs.cus_name_typeahead.inputValue = "";
      }
    },
    // remove row option
    removeRow(index) {
      if (this.items.length > 1) {
        this.items.splice(index, 1);
      }
    },
    //change exchange rate
    async changeExchangeRate() {
      this.old_exchange_rate = this.field.unit_currency_value;
      this.field.unit_currency_value =
        parseFloat(this.field.unit_currency_value) <= 0 ||
        this.field.unit_currency_value == ""
          ? 1
          : this.field.unit_currency_value;
    },
    // get exchange rate value with transcation date
    getExchangeRateValue(date_change) {
      this.$store
        .dispatch("customer/getCurrencyRate", {
          id: this.field.cus_id,
          currency_id: this.field.cus_currency,
          date: this.field.retainer_date
        })
        .then(() => {
          this.field.unit_currency_value =
            this.currency_details.currency_exchange_rate != "" &&
            this.currency_details.currency_exchange_rate > 0
              ? this.currency_details.currency_exchange_rate
              : this.old_exchange_rate;
          this.field.currency_code = this.currency_details.currency_code;
          if (
            this.old_cus_id != this.field.cus_id &&
            this.old_currency_code != this.field.currency_code
          ) {
            this.changed_currency = true;
            if (
              this.field.currency_code != this.orgCurrency &&
              this.old_currency_code != ""
            ) {
              if (this.items.some(x => x.pdt_id != "") && date_change != 1) {
                this.$root.$emit("bv::show::modal", "cus_change_exchange_rate");
              }
            }
          } else {
            this.changed_currency = this.page == "update" ? false : true;
          }
        });
    },
    // currency exchange rate dropdown form submit
    exchangeRateSubmit() {
      if (this.exchange_rate_details.save_exchange_rate == 1) {
        var data = {
          currency_id: this.field.cus_currency,
          date: this.field.retainer_date,
          value: this.exchange_rate_details.currency_exchange_rate,
          code: this.field.currency_code
        };
        data = JSON.stringify(data);
        this.$store.dispatch("currency/addExchangeRate", data).then(() => {
          this.submitted = false;
          if (this.exchange_rate_type == "success") {
            this.error_msg = false;
            //to show the alert message for success or error after api call
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.exchange_rate_message,
              type: this.exchange_rate_type,
              showCloseButton: true
            });
          } else {
            this.error_msg = true;
          }
        });
      }
      this.old_exchange_rate = this.exchange_rate_details.currency_exchange_rate;
      this.field.unit_currency_value = this.exchange_rate_details.currency_exchange_rate;
      // hide dropdown exchange_rate_dropdown
      this.$refs.exchange_rate_dropdown.hide(true);
    },
    //validation during onsubmit
    onSubmit(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          //  send the json data
          var data = JSON.stringify({
            header_details: this.field,
            old_retainer_itm_ids: this.old_retainer_itm_ids,
            item_details: this.items
          });

          this.$emit("onSubmit", data);
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          this.error_show = true; // show validation message
        }
      });
      return false;
    },
    // add new row option
    addNewRow() {
      this.items.push({
        inv_notes: "",
        retainer_amt: "",
        retainer_total: ""
      });
    },
    createFreshEventObject() {
      // empty details for header
      return {
        type: "customer_deposit",
        code_id: "",
        prefix: "",
        suffix: "",
        retainer_no: "",
        currency_code: this.orgCurrency,
        is_export: 1,
        unit_currency_value: 1,
        cus_id: "",
        retainer_date: this.formatDate(new Date()),
        ref_no: "",
        retainer_notes: "",
        retainer_terms_cndtn: "",
        cus_inv_notes: "",
        retainer_status_id: 5,
        retainer_total: "",
        search_value: []
      };
    },
    updateFields() {
      if (this.page == "update") {
        this.changed_currency = false;
        for (
          var i = 0;
          i < this.retainer_settings_details.custom_field.length;
          i++
        ) {
          this.field[
            this.retainer_settings_details.custom_field[i].field_name
          ] = this.list.header_details[
            this.retainer_settings_details.custom_field[i].field_name
          ];
        }
        this.old_retainer_itm_ids = this.list.old_retainer_itm_ids;
        this.field = this.list.header_details;
        this.field.deposit_desc_changed = 0;
        this.field.deposit_term_changed = 0;
        this.field.exchange_rate_status = this.org_details.exchange_rate_status;
        this.old_cus_id = this.field.cus_id;
        this.old_currency_code = this.field.currency_code;
        this.old_exchange_rate = this.field.unit_currency_value;
        this.items = this.list.item_details;
        this.cus_id = this.list.header_details.cus_name;
      } else if (this.$route.query.quot_id) {
        this.field.cus_id = this.list.header_details.cus_id;
        this.field.cus_currency = this.list.header_details.cus_currency;
        this.field.unit_currency_value = this.list.header_details.unit_currency_value;
        this.field.quot_hdr_id = this.list.header_details.quot_hdr_id;
        this.field.exchange_rate_status = this.org_details.exchange_rate_status;
        this.old_cus_id = this.list.header_details.cus_id;
        this.old_currency_code = this.list.header_details.currency_code;
        this.old_exchange_rate = this.list.header_details.unit_currency_value;
        this.cus_id = this.list.header_details.cus_name;
        this.getExchangeRateValue();
      }
    }
  },
  watch: {
    total: {
      deep: true,
      handler: function(val) {
        this.field.retainer_total = val;
      }
    },
    cus_id(val) {
      if (val != "" && val.length > 2) {
        var data = {
          search_value: val,
          search_column: this.search_column
        };
        this.$store
          .dispatch("general/fetchCustomerAdvanceSearchData", data)
          .then(() => {
            this.customers = this.customer_filter_list;
          });
      }
    }
  },
  async created() {
    this.field.deposit_desc_changed = 0;
    this.field.deposit_term_changed = 0;
    this.field.exchange_rate_status = this.org_details.exchange_rate_status;
    this.field.code_id = this.details.active_code_id.code_id;
    this.field.suffix = this.details.active_code_id.suffix;
    this.field.prefix = this.details.active_code_id.prefix;
    this.field.retainer_no =
      this.details.active_code_id.prefix + this.details.active_code_id.suffix;
    this.field.retainer_terms_cndtn = this.retainer_settings_details.internal_notes;
    this.field.cus_inv_notes = this.retainer_settings_details.cus_inv_notes;
    if (this.page == "update") {
      this.currency_details = {};
      document.title = getPageTitle(
        this.list.header_details.retainer_no + " | " + this.$route.meta.title
      );
    }
    for (
      var i = 0;
      i < this.retainer_settings_details.custom_field.length;
      i++
    ) {
      if (this.retainer_settings_details.custom_field[i].status == 1 && this.retainer_settings_details.custom_field[i].permissions == 'write') {
        this.$set(
          this.field,
          this.retainer_settings_details.custom_field[i].field_name,
          this.retainer_settings_details.custom_field[i].default_value
        );
      }
    }

    //  wait for update
    await this.updateFields();
    //  to watch any updates in details data
    await this.$watch(
      "field",
      function() {
        this.$emit("FormUpdate");
      },
      {
        deep: true
      }
    );
    //  to watch any updates in details data
    await this.$watch(
      "items",
      function() {
        this.$emit("FormUpdate");
      },
      {
        deep: true
      }
    );
    if (this.$route.query.customer_id) {
      this.field.cus_id = this.$route.query.customer_id;

      this.$refs.cus_name_typeahead.inputValue = this.customer_data.cus_display_name;
      this.update_price = await true;

      await this.checkpos({
        value: this.customer_data.cus_id,
        currency: this.customer_data.cus_currency,
        pos: this.customer_data.place_of_supply
      });
    }
  },
  updated: function() {
    this.$nextTick(function() {
      if (this.update_price == false && this.$route.params.id) {
        //update prodcut price
        var cus_name = this.list.header_details.cus_name;
        this.cus_id = cus_name;
        this.$refs.cus_name_typeahead.inputValue = cus_name;
        $("#customer_search input").addClass("mask");
        $("#customer_search .input-group").append(
          "<span class='la la-close p-2 mt-1 remover cursor_pointer bg-white'></span>"
        );
        this.update_price = true;
      } else {
        this.update_price = true;
      }
    });
  },
  //To calculate the total
  computed: {
    ...mapState({
      details: state => state.retainer.details,
      list: state => state.retainer.list,
      message: state => state.retainer.message,
      customer_filter_list: state => state.general.customer_filter_list,
      exchange_rate_message: state => state.currency.message,
      exchange_rate_type: state => state.currency.type,
      customer_data: state => state.customer.listView.main_detail
    }),
    currency_details: {
      get() {
        return this.$store.state.customer.currency_details;
      },
      set(val) {
        this.$store.state.customer.currency_details = val;
      }
    },
    ...mapGetters([
      "orgCurrency",
      "orgCurrencySymbol",
      "retainer_settings_details",
      "org_details"
    ]),
    total() {
      var total_paid_amount = this.items.reduce(function(total, value) {
        return !isNaN(parseFloat(value.retainer_amt))
          ? total + parseFloat(value.retainer_amt)
          : parseFloat(total);
      }, 0);

      var total_amount = parseFloat(total_paid_amount).toFixed(2);
      return total_amount;
    }
  }
};
</script>
<style scoped>
.create-cus {
  margin-right: 20px !important;
  height: 29px;
  margin-top: 0px !important;
}

.customer_search {
  width: 657px;
}
</style>